import useConfiguration from '@/composables/configuration/configuration'

const { configuration } = useConfiguration()

let positionsStack: number[] = []
let initializedStack = false

function ensurePositionsStack() {
  if (!initializedStack) {
    positionsStack = Array.from(configuration.advertPositions)
    initializedStack = true
  }
}

export default function useAdvertPositionsManager() {
  const popNextAdvertPosition = (): number | undefined => {
    ensurePositionsStack()

    if (positionsStack.length > 0) {
      const nextPosition = positionsStack[0]
      positionsStack = positionsStack.slice(1, positionsStack.length)

      return nextPosition
    }

    return undefined
  }

  const pushNextAdvertPosition = (position: number): void => {
    positionsStack.push(position)
  }

  return {
    popNextAdvertPosition,
    pushNextAdvertPosition,
  }
}
